define([
    "lodash",
    "../../arrays/arrays",
    "./../nlgLGPDModule",
    "json!../../tdnHelp/tdnSpecification.json"
], function (_, arrays, lgpdModule, tdnSpecification) {
    "use strict";

    return lgpdModule.controller("nlgLGPDLogsController", [
        "$scope",
        "autocompleteFactory",
        "messagesModal",
        "remoteExceptionHandler",
        "$state",
        "$q",
        "loadingService",
        "nlgLGPDService",
        "$translate",
        "$filter",
        "xlsService",
        "tdnHelp",
        "spreadsheetExportService",
        function ($scope, autocompleteFactory, messagesModal, remoteExceptionHandler, $state, $q, loadingService, nlgLGPDService, $translate, $filter, xlsService, tdnHelp, spreadsheetExportService) {
            var paginationApi;
            $scope.maxResultsSpreadSheet = 0;

            if (tdnSpecification && tdnSpecification[tdnHelp.getContext()] && tdnSpecification[tdnHelp.getContext()]["logs"]) {
                $scope.tdn = tdnSpecification[tdnHelp.getContext()]["logs"];
            }
            $scope.context = tdnHelp.getContext();

            $scope.model = {
                entityDefinition: null,
                entityField: null
            };

            $scope.getActionName = function (tag) {
                if (!tag) return "";
                return $translate.instant(tag);
            };

            $scope.getEntityName = function (tag) {
                if (!tag) return "";
                return "(" + _.capitalize($translate.instant(tag.artifactName)) + "/" +
                    _.capitalize(tag.translatedServiceName) + ") - " + tag.presentationName;
            };

            $scope.getEntityFieldName = function (tag) {
                if (!tag) return "";
                if (!tag.presentationField) return tag.entityField;
                return tag.presentationField;
            };

            $scope.getAllDefinitionEntityNames = function () {
                $scope.serviceName = nlgLGPDService.availableServiceNames();
                return $q.all(nlgLGPDService.getAlreadLogDefinitions())
                    .then(function (allItems) {
                        var resultNames = [];
                        allItems.forEach(function (entry) {
                            entry.value.forEach(function (name) {
                                var nameEntry = {
                                    entityName: name.entityName,
                                    presentationName: name.presentationName,
                                    artifactName: entry.key.artifactName,
                                    serviceName: name.type.description,
                                    translatedServiceName: $translate.instant(name.type.description)
                                };
                                resultNames.push(nameEntry);
                            });
                        });
                        return resultNames;
                    });
            };

            $scope.getEntitiesByName = function (definiton) {
                var template = {
                    entityName: definiton.entityName,
                    presentationName: definiton.presentationName,
                    type: {"description": definiton.serviceName},
                    artifactName: definiton.artifactName
                };
                return nlgLGPDService.getLogEntitiesByServicePathAndTemplate(template);
            };

            $scope.getLogTypes = function () {
                return nlgLGPDService.getLogTypes();
            };

            $scope.findEntities = function () {
                return paginationApi.seekPage(1);
            };

            $scope.checkEntity = function () {
                if (!$scope.model.entityDefinition) {
                    $scope.model.entityField = null;
                }
            };

            $scope.exportSpreedSheet = function () {
                var data = prepareRequestData();
                var dataToExport = [];
                nlgLGPDService.getlogEntities(data, 0, $scope.maxResultsSpreadSheet)
                    .then(function (response) {
                        arrays.each(response.data.logsEntities, function (logEntity) {
                            logEntity.entityName = $translate.instant(data.serviceName) + " - " + logEntity.entityName;
                            logEntity.action = $translate.instant(logEntity.action);
                            var parameters = logEntity.parameters ? JSON.parse(logEntity.parameters) : null;
                            logEntity.justification = $translate.instant(logEntity.justification, parameters);
                            logEntity.success = $translate.instant(logEntity.success ? "lgpd.log.action.success" : "lgpd.log.action.fail");
                            dataToExport.push(createResultRow(logEntity));
                        });
                        var spreadsheetName = $translate.instant("lgpd.logs.spreadsheet");
                        return spreadsheetExportService.exportSpreadsheet(spreadsheetName, spreadsheetName, createResultHeaders(), dataToExport);
                    }).catch(remoteExceptionHandler());
            };

            function createResultHeaders() {
                return [
                    $translate.instant("lgpd.logs.action.date"),
                    $translate.instant("lgpd.logs.user"),
                    $translate.instant("lgpd.logs.entity"),
                    $translate.instant("lgpd.logs.entity.field"),
                    $translate.instant("lgpd.logs.action"),
                    $translate.instant("lgpd.logs.entity.code"),
                    $translate.instant("lgpd.logs.entity.name"),
                    $translate.instant("lgpd.logs.value"),
                    $translate.instant("lgpd.logs.result"),
                    $translate.instant("lgpd.logs.justification")
                ];
            }

            function createResultRow(logEntity){
                return [
                    $filter("date")(logEntity.auditedDate, "dd/MM/yyyy H:mm"),
                    logEntity.userCode,
                    logEntity.presentationName,
                    logEntity.presentationField || logEntity.entityField,
                    logEntity.action,
                    clearValue(logEntity.code),
                    clearValue(logEntity.name),
                    clearValue(logEntity.value),
                    logEntity.success,
                    clearValue(logEntity.justification)
                ];
            }

            $scope.exportDefinitions = function () {
                return loadingService($q.all(nlgLGPDService.getLgpdLogRows()))
                    .then(function (allItems) {
                        var dataToExport = [];
                        allItems.forEach(function (entry) {
                            var artifactName = _.capitalize(entry.key.artifactName);
                            entry.value.forEach(function (definition) {
                                dataToExport.push(createDefinitionRow(definition, artifactName));
                            });
                        });
                        var spreadsheetName = $translate.instant("lgpd.logs.spreadsheet.definitions");
                        return spreadsheetExportService.exportSpreadsheet(spreadsheetName, spreadsheetName, createDefinitionHeaders(), dataToExport);
                    });
            };

            function createDefinitionHeaders() {
                return [
                    "auditedDate",
                    "userCode",
                    "presentationName",
                    "presentationField",
                    "personal",
                    "sensitive",
                    "anonymizable",
                    "justification"
                ];
            }

            function createDefinitionRow(definition, artifactName){
                var type = $translate.instant(definition.type.description);
                return [
                    $filter("date")(definition.auditedDate, "dd/MM/yyyy H:mm"),
                    definition.userCode,
                    artifactName + " - (" + type + ") " + definition.presentationName,
                    definition.presentationField,
                    definition.personal,
                    definition.sensitive,
                    definition.anonymizable,
                    definition.justification
                ];
            }

            $scope.tableOptions = {
                records: [],
                onRegisterPagination: function (api) {
                    paginationApi = api;
                },
                pagination: {
                    onPaginate: function (firstResult, maxResults) {

                        var data = prepareRequestData();

                        return loadingService(nlgLGPDService.getlogEntities(data, firstResult, maxResults)
                            .then(function (response) {
                                $scope.maxResultsSpreadSheet = response.data.count;
                                var definitions = [];
                                arrays.each(response.data.logsEntities, function (logEntity) {
                                    logEntity.presentationName = $translate.instant(data.serviceName) + " - " + logEntity.presentationName;
                                    logEntity.action = $translate.instant(logEntity.action);
                                    var parameters = logEntity.parameters ? JSON.parse(logEntity.parameters) : null;
                                    logEntity.justification = $translate.instant(logEntity.justification, parameters);
                                    logEntity.success = $translate.instant(logEntity.success ? "lgpd.log.action.success" : "lgpd.log.action.fail");
                                    definitions.push(logEntity);
                                });
                                return {
                                    result: definitions,
                                    count: response.data.count,
                                    firstResult: response.data.firstResult,
                                    maxResults: maxResults
                                };
                            }).catch(remoteExceptionHandler()));
                    }
                }
            };

            function prepareRequestData() {
                var entityField = null;
                var logType = null;
                if ($scope.model.entityField && $scope.model.entityField.entityField) {
                    entityField = $scope.model.entityField.entityField;
                }
                if ($scope.model.action) {
                    logType = $scope.model.action;
                }
                var template = {
                    entityName: $scope.model.entityDefinition.entityName,
                    entityField: entityField,
                    type: {"description": $scope.model.entityDefinition.serviceName},
                    logType: logType
                };
                return {
                    findBy: template,
                    serviceName: $scope.model.entityDefinition.serviceName,
                    artifactName: $scope.model.entityDefinition.artifactName
                };
            }

            function clearValue(value) {
                return value || "";
            }
        }]);
});